import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import {Container, Row, Col} from './BootstrapGrid';
import {Title} from './Typography';

class HeroSection extends Component {
  constructor(props) {
    super(props);

    this.style = {
      textAlign: "center",
      backgroundColor: this.props.muiTheme.palette.primary1Color,
      color: this.props.muiTheme.palette.alternateTextColor,
      paddingTop: "2em",
      paddingBottom: "2em",
      fontFamily: this.props.muiTheme.fontFamily,
    }
  }

  render() {
    return (
      <div style={this.style}>
        <Container style={{
              maxWidth: '90%',
              width: '600px',
              margin: 'auto'
            }}>
          <Row className="row">
            <Col cols={12}>
              <Title alternateColor={true}>{this.props.header}</Title>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default muiThemeable()(HeroSection);



// WEBPACK FOOTER //
// ./src/HeroSection.js